/* eslint-disable import/prefer-default-export */
export const ARCHIVE_GROUP_SETTING = {
  searchCriteria: null,
  startDate: null,
  endDate: null,
  isArchive: 'all',
}
